var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagesBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9537 4H5.04746C4.24895 4 3.59961 4.64913 3.59961 5.44858V14.553C3.59961 15.3516 4.24895 16 5.04746 16H14.9537C15.7522 16 16.4009 15.3516 16.4009 14.553V5.44858C16.4009 4.64913 15.7522 4 14.9537 4ZM11.8776 6.15432C12.6498 6.15432 13.276 6.78061 13.276 7.55276C13.276 8.32492 12.6497 8.95121 11.8776 8.95121C11.1052 8.95121 10.4791 8.32492 10.4791 7.55276C10.4791 6.78061 11.1052 6.15432 11.8776 6.15432ZM14.4997 14.6616H10.0001H5.70105C5.31482 14.6616 5.14281 14.3822 5.31692 14.0374L7.71691 9.28383C7.89081 8.93912 8.22223 8.90836 8.45693 9.21505L10.8702 12.3688C11.1049 12.6756 11.5151 12.7017 11.7866 12.4268L12.377 11.829C12.6483 11.5542 13.048 11.5882 13.2695 11.9045L14.7982 14.0882C15.0192 14.405 14.8859 14.6616 14.4997 14.6616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesBorder);
export default __webpack_public_path__ + "static/media/images_border.0691c6ea255a5f51e42b5acde5476b68.svg";
export { ForwardRef as ReactComponent };